(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('play-integrity-log', {
            parent: 'entity',
            url: '/play-integrity-log?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.playIntegrityLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-logs.html',
                    controller: 'PlayIntegrityLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: null,
                status: null,
                endpoint: null,
                appLicensingVerdict: null,
                appRecognitionVerdict: null,
                deviceRecognitionVerdict: null,
                appVersionCode: null,
                fromDate: null,
                toDate: null,
                from: null,
                to: null,
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        phone: $stateParams.phone,
                        status: $stateParams.status,
                        endpoint: $stateParams.endpoint,
                        appLicensingVerdict: $stateParams.appLicensingVerdict,
                        appRecognitionVerdict: $stateParams.appRecognitionVerdict,
                        deviceRecognitionVerdict: $stateParams.deviceRecognitionVerdict,
                        appVersionCode: $stateParams.appVersionCode,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        from: $stateParams.from,
                        to: $stateParams.to,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('playIntegrityLog');
                    $translatePartialLoader.addPart('playIntegrityStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('play-integrity-log-detail', {
            parent: 'play-integrity-log',
            url: '/play-integrity-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.playIntegrityLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-detail.html',
                    controller: 'PlayIntegrityLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('playIntegrityLog');
                    $translatePartialLoader.addPart('playIntegrityStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PlayIntegrityLog', function($stateParams, PlayIntegrityLog) {
                    return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'play-integrity-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('play-integrity-log-detail.edit', {
            parent: 'play-integrity-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-dialog.html',
                    controller: 'PlayIntegrityLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlayIntegrityLog', function(PlayIntegrityLog) {
                            return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('play-integrity-log.new', {
            parent: 'play-integrity-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-dialog.html',
                    controller: 'PlayIntegrityLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                endpoint: null,
                                uuid: null,
                                phone: null,
                                nonce: null,
                                integrityToken: null,
                                responseJson: null,
                                status: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('play-integrity-log', null, { reload: 'play-integrity-log' });
                }, function() {
                    $state.go('play-integrity-log');
                });
            }]
        })
        .state('play-integrity-log.edit', {
            parent: 'play-integrity-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-dialog.html',
                    controller: 'PlayIntegrityLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PlayIntegrityLog', function(PlayIntegrityLog) {
                            return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('play-integrity-log', null, { reload: 'play-integrity-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('play-integrity-log.delete', {
            parent: 'play-integrity-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/play-integrity-log/play-integrity-log-delete-dialog.html',
                    controller: 'PlayIntegrityLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PlayIntegrityLog', function(PlayIntegrityLog) {
                            return PlayIntegrityLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('play-integrity-log', null, { reload: 'play-integrity-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
